"use client";
import React from "react";
import PageLayout from "@/layouts/pageLayout";
import PocCloudTabs from "@/components/pageTabs/pocCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import FeaturesComponent from "./components/features";
import BenefitsComponent from "./components/benefits";

const PhysicalLabsPage = () => {
  return (
    <PageLayout showContactForm>
      <Hero />
      <PocCloudTabs />
      <Intro />
      <FeaturesComponent />
      <BenefitsComponent />
      <Faqs />
    </PageLayout>
  );
};

export default PhysicalLabsPage;
